// extracted by mini-css-extract-plugin
export default {"container":"AdminNavigation_container__rwXXA","nav__list":"AdminNavigation_nav__list__pTKy5","nav__link":"AdminNavigation_nav__link__tS1ec"};